import { handleActions } from "redux-actions";
import { produce } from "immer";

import { LOG_OUT } from "../system/actions";
import {
  SET_SALES_TRANSACTIONS_FIRESTORE_LOADING,
  SET_SALES_TRANSACTIONS_INITIAL_SYNC_COMPLETE,
  SET_UNREVIEWED_PRESENCE,
} from "./actions";
import type { UnreviewedPresence } from "./actions";

export interface UserDataLoadState {
  salesTransactionsFirestoreLoading: boolean;
  initialSalesTransactionsSyncComplete: boolean;
  unreviewedPresence: UnreviewedPresence;
}

export const userDataLoadInitialState: UserDataLoadState = {
  salesTransactionsFirestoreLoading: false,
  initialSalesTransactionsSyncComplete: false,
  unreviewedPresence: {
    sales: false,
    returns: false,
    transactions: false,
  },
};

export const userDataLoadReducer = handleActions<UserDataLoadState, any>(
  {
    [SET_SALES_TRANSACTIONS_FIRESTORE_LOADING]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.salesTransactionsFirestoreLoading = !!payload;
      }),
    [SET_SALES_TRANSACTIONS_INITIAL_SYNC_COMPLETE]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.initialSalesTransactionsSyncComplete = !!payload;
      }),
    [SET_UNREVIEWED_PRESENCE]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.unreviewedPresence = {
          ...draft.unreviewedPresence,
          ...(payload || {}),
        };
      }),
    [LOG_OUT]: () => ({
      ...userDataLoadInitialState,
      unreviewedPresence: { ...userDataLoadInitialState.unreviewedPresence },
    }),
  },
  userDataLoadInitialState
);
